import React, { useState, useEffect, useRef } from "react";
import "./infoicon.css";

const InfoIcon = ({ content }) => {
  const [showInfo, setShowInfo] = useState(false);
  const infoBoxRef = useRef(null); // Ref for the info box

  // Close the pop-up if the user clicks outside the icon or the pop-up
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        infoBoxRef.current &&
        !infoBoxRef.current.contains(event.target) &&
        !event.target.classList.contains("info-icon") // Ensure the icon itself doesn't trigger this
      ) {
        setShowInfo(false);
      }
    };

    // Add event listener when the pop-up is open
    if (showInfo) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Clean up the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showInfo]);

  return (
    <div className="info-icon-container">
      <span
        className="info-icon"
        onClick={() => setShowInfo(!showInfo)} // Toggle on click
        aria-label="More information"
        aria-expanded={showInfo}
      >
        i
      </span>
      {showInfo && (
        <div className="info-box" ref={infoBoxRef}>
          {content}
          <button onClick={() => setShowInfo(false)}>Close</button>
        </div>
      )}
    </div>
  );
};

export default InfoIcon;